import { useQuery } from '@tanstack/react-query'
import { getProcessCarriers } from '@/api/processes-api'
import { toProcessEcommerceScope } from './process-ecommerce-scope'

export const useProcessCarriers = (ecommerceIds?: string[]) => {
  return useQuery({
    queryKey: ['process-carriers', ecommerceIds],
    queryFn: async ({ signal }) => {
      const response = await getProcessCarriers(
        { pbFindProcessCarriersRequest: toProcessEcommerceScope(ecommerceIds) },
        signal
      )
      return response.carriers ?? []
    },
    staleTime: Infinity
  })
}
